/* /* /* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState} from "react";
import { useHeaderStates } from '../../Providers/HeaderStates';
import { ContactUs } from '../../components/ContactUs';
import { OtherServices } from '../../components/OtherServices';
import { useStartupState } from '../../Providers/StartupState';
import { baseUrlImg, handleGetData } from '../../Api';
import { Capa } from '../../components/Capa';
import { Loading } from '../../components/Loading';
import { ReactMarkdown } from 'react-markdown/lib/react-markdown';
/* import { Truck, MapPin, Wrench, Phone, Zap } from "lucide-react"; */
import InlineSVG from '../../components/InlineSVG/index';
import * as S from './style';

export const TrrCopasul = () => {
  const [data, setData] = useState(null);

  const { setTitle, setBgHeader } = useHeaderStates();
  const { token, setError, loading, setLoading } = useStartupState();

 /*  // ⬇️ MOVIDOS PARA CIMA, antes dos useMemo
  const ICONS = { Truck, MapPin, Wrench, Phone, Zap };

  const items = [
    {
      icon: "Truck",
      title: "Compra e Revenda de Combustíveis",
      desc:
        "O TRR adquire grandes volumes de óleo diesel, lubrificantes e graxas e os revende em quantidades menores para os clientes.",
    },
    {
      icon: "MapPin",
      title: "Transporte e Entrega",
      desc:
        "Possui frota própria para transportar e entregar os produtos diretamente nas propriedades rurais e outros locais de consumo.",
    },
    {
      icon: "Wrench",
      title: "Qualidade e Segurança",
      desc:
        "Garante a qualidade dos produtos, seguindo as normas e padrões estabelecidas pela ANP e outras legislações pertinentes.",
    },
    {
      icon: "Truck",
      title: "Logística Facilitada",
      desc:
        "Oferece soluções logísticas para otimizar o abastecimento de combustível e lubrificantes, evitando interrupções e reduzindo custos.",
    },
    {
      icon: "Phone",
      title: "Atendimento Personalizado",
      desc:
        "Proporciona atendimento especializado e consultoria para atender as necessidades específicas de cada cliente.",
    },
    {
      icon: "Zap",
      title: "Suporte aos Cooperados",
      desc:
        "Uma estrutura construída para trazer mais comodidade logística e qualidade aos cooperados da Copasul.",
    },
  ]; */

  useEffect(() => {
    setError(null);
    setLoading(true);
    if (token) {
      handleGetData(token, 'api/content/copasul/combustivel/')
        .then((response) => {
          setData(response?.data?.items[0]?.data);
          if (response?.status !== 200) {
            throw new Error(response.message);
          }
        })
        .catch((e) => {
          setData(null);
          console.log(e.message);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [token, setError, setLoading]);

  // A página tem a própria capa: a faixa verde com o título, que o Header
  // desenha a partir do setTitle, fica desligada.
  useEffect(() => {
    setTitle(null);
    setBgHeader(null);
  }, [setTitle, setBgHeader]);

  if (loading) {
    return <Loading />;
  }

  return (
    <div style={{ position: 'relative' }}>
      {/* a foto do caminhão vai atrás do título; sem ela, a de header */}
      <Capa
        imagem={[data?.bannerPrincipal?.iv?.imagemBackground?.[0], data?.imagemHeader?.iv?.[0]]}
        titulo={data?.titulo?.iv}
      />

      {/* a foto deste bloco subiu para a Capa */}
        <S.Container>
        <S.ContentBannersBox>
          <ReactMarkdown className="ReactMarkdown">
            {data?.bannerPrincipal?.iv?.conteudoMarkdown || ''}
          </ReactMarkdown>
        </S.ContentBannersBox>
      </S.Container>


      <S.TRRSection>

        <OtherServices
          servicesLinks={data?.cartoesServicos?.iv}
          marginTop={'-8rem'}
        />
        <S.Container>
          <S.Title>{data?.GridTRR?.iv?.TituloGeral}</S.Title>

          <S.TRRGrid>
            {data?.GridTRR?.iv?.listainformacao?.map((item, i) => (
              <S.TRRItem key={i}>
                <S.IconWrap>
                  {/* <InlineSVG url={`${baseUrlImg}${item.Imagem}`} /> */}
                  <InlineSVG size={32} url={item.Imagem ? `${baseUrlImg}${item.Imagem}` : '/default-icon.svg'} />
                </S.IconWrap>
                <div>
                  <S.ItemTitle>{item?.Titulo}</S.ItemTitle>
                  <S.ItemText>{item?.Descricao}</S.ItemText>
                </div>
              </S.TRRItem>
          ))}
          </S.TRRGrid>

        </S.Container>
    </S.TRRSection>
      <ContactUs />

    </div>
  );
};
